<template>
  <model :feature-list="featureList" :page-data="pageData"></model>
</template>

<script>
import model from './model.vue'

export default {
  components: {
    model
  },
  data () {
    return {
      pageData: {
        overview: {
          label: '电子档案质量检测概览',
          title: '用可追溯的四性检测支撑电子档案可信利用',
          description: '集中管理检测任务、执行规则和异常结果，帮助工作人员快速定位问题并完成核验。',
          tags: ['真实性', '完整性', '可用性', '安全性'],
          panel: {
            title: '四性检测工作台',
            summaryLabel: '待执行检测任务',
            summaryValue: '32 项',
            rows: [
              { label: '真实性', value: '99.8% 通过', tone: 'positive' },
              { label: '完整性', value: '3 项待复核', tone: 'warning' },
              { label: '可用性', value: '98.6% 通过', tone: 'positive' },
              { label: '安全性', value: '未发现风险', tone: 'positive' }
            ],
            footer: '检测依据、异常项与核验记录统一留存'
          },
          values: [
            { title: '检测有据', description: '围绕四性要求建立清晰的检测依据。' },
            { title: '风险可见', description: '及时展示异常结果，辅助定位问题。' },
            { title: '结果可用', description: '为归档、保存和利用提供质量支撑。' }
          ]
        },
        featureSection: {
          title: '围绕四性要求开展规范检测',
          description: '将检测项目、执行规则和结果核验集中管理，让电子档案质量检查更加清晰、可追溯。'
        },
        process: {
          title: '形成清晰可执行的检测闭环',
          description: '从确定检测范围到查看结果整改，持续保障电子档案质量。',
          steps: [
            { title: '选择档案范围', description: '根据归档和管理要求确定待检档案。' },
            { title: '配置检测规则', description: '设置真实性、完整性、可用性和安全性检查要求。' },
            { title: '执行四性检测', description: '按规则自动完成检测任务并汇总结果。' },
            { title: '查看结果并整改', description: '定位异常项，形成后续处理与核验依据。' }
          ]
        }
      },
      featureList: [
        {
          feature: '检测项目配置、规则执行与结果核验',
          description: [
            '围绕电子档案真实性、完整性、可用性和安全性要求，统一配置检测项目与执行规则。',
            '集中查看检测任务、异常结果与核验信息，为问题整改和质量管理提供依据。'
          ],
          src2: require('../../assets/images/solution-img-2.jpg')
        }
      ]
    }
  }
}
</script>
